import React from 'react';

const Search = () => {
  return (
    <svg
      version="1.1"
      id="searchIcon"
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 31 31"
      style="enable-background:new 0 0 31 31;"
      space="preserve"
      style={{
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        stroke: 'currentColor',
        strokeWidth: 2,
        strokeMiterlimit: 10,
        verticalAlign: 'middle',
      }}
    >
      <path d="M19.78,20.63c-1.91,1.72-4.43,2.76-7.19,2.76c-5.93,0-10.75-4.82-10.75-10.75S6.65,1.88,12.59,1.88 S23.34,6.7,23.34,12.64c0,2.76-1.04,5.29-2.76,7.19L29,28.25l-0.8,0.8L19.78,20.63z M12.59,3.02c5.31,0,9.62,4.31,9.62,9.62 s-4.31,9.62-9.62,9.62s-9.62-4.31-9.62-9.62S7.28,3.02,12.59,3.02z" />
    </svg>
  );
};

export default Search;
